export default __webpack_public_path__ + "static/media/star-cinema.62e124e7.png";